import { useState } from "react"
import { galleryImages } from "../../data/data"

export default function GalleryImages() {
  const [images] = useState(galleryImages)

  return (
    <>
      <section className="max-width py-10 xl:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2">
          {images.map(({ id, image }) => (
            <article key={id}>
              <img src={image} alt="gallery" />
            </article>
          ))}
        </div>
      </section>
    </>
  )
}
